import { render } from "./CardSeries.vue?vue&type=template&id=048818d2&scoped=true"
import script from "./CardSeries.vue?vue&type=script&lang=js"
export * from "./CardSeries.vue?vue&type=script&lang=js"

import "./CardSeries.vue?vue&type=style&index=0&id=048818d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-048818d2"]])

export default __exports__